/* Skin Theory · Warum Tallow – Interaktion für die Sections st-wt-* (Inhalte kommen aus dem Theme-Editor) */
(()=>{
if(window.__stWt)return;window.__stWt=1;
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const NS='http://www.w3.org/2000/svg';
const RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
const top_=el=>el.getBoundingClientRect().top+window.scrollY;

/* Hautschnitt */
const skin=$('#skin');
if(skin){
  const card=skin.closest('.skin-card'), btns=[...card.querySelectorAll('.seg button')];
  const bricks=$('#bricks'), drops=$('#drops');
  for(let r=0;r<4;r++){
    const y=124+r*28, off=r%2?-44:-6;
    for(let x=off;x<640;x+=82){
      const b=document.createElementNS(NS,'rect');
      b.setAttribute('x',x);b.setAttribute('y',y);b.setAttribute('width',74);b.setAttribute('height',22);b.setAttribute('rx',3);
      b.setAttribute('fill','#E9DFCF');b.setAttribute('stroke','#D8CDB9');bricks.appendChild(b);
    }
  }
  [40,104,170,232,300,362,428,488,548,604].forEach((x,i)=>{
    const c=document.createElementNS(NS,'circle');
    c.setAttribute('cx',x);c.setAttribute('cy',262+(i%3)*10);c.setAttribute('r',6);
    c.setAttribute('class','drop d'+(i+1));drops.appendChild(c);
  });
  for(let i=0;i<9;i++){
    const c=document.createElementNS(NS,'circle');
    c.setAttribute('cx',70+i*66);c.setAttribute('cy',250+(i%2)*28);c.setAttribute('r',4.5);
    c.setAttribute('fill','#7F9CA8');c.setAttribute('opacity','.45');drops.appendChild(c);
  }
  /* Talg-Schleife: dicker Klecks oben -> zieht in die oberen Fugen -> dünne Schicht bleibt -> von vorn */
  const tG=$('#talgG'), tF=$('#talgFilm'), tM=$('#talgMortar'), fR=$('#fillRect');
  let raf=0, t0=0;
  const ease=x=>x<.5?2*x*x:1-Math.pow(-2*x+2,2)/2;
  const film=th=>{
    let d='M0 118 L0 '+(118-th);
    for(let x=0;x<=640;x+=40){d+=' Q'+(x+20)+' '+(118-th-(x%80?3:-3)*(th/40))+' '+(x+40)+' '+(118-th);}
    return d+' L640 118 Z';
  };
  const frame=now=>{
    const p=((now-t0)%7000)/7000;
    let op,th,fill;
    if(p<.10){op=ease(p/.10);th=44;fill=0;}
    else if(p<.62){const k=ease((p-.10)/.52);op=1;th=44-26*k;fill=k;}
    else if(p<.90){op=1;th=18;fill=1;}
    else {op=1-(p-.90)/.10;th=18;fill=1;}
    tG.setAttribute('opacity',op);tF.setAttribute('d',film(th));
    tM.setAttribute('opacity',p<.90?.95:.95*(1-(p-.90)/.10));fR.setAttribute('height',64*fill);
    raf=requestAnimationFrame(frame);
  };
  const talgOn=on=>{
    cancelAnimationFrame(raf);
    if(!on){tG.setAttribute('opacity',0);tM.setAttribute('opacity',0);return;}
    if(RM){tG.setAttribute('opacity',1);tF.setAttribute('d',film(18));tM.setAttribute('opacity',.95);fR.setAttribute('height',64);return;}
    t0=performance.now();raf=requestAnimationFrame(frame);
  };
  const cap=$('#skinCap');
  const setSkin=b=>{
    skin.dataset.s=b.dataset.s;talgOn(b.dataset.s==='talg');
    btns.forEach(x=>x.setAttribute('aria-pressed',x===b));
    cap.innerHTML='';const t=document.createElement('b');t.textContent=b.dataset.capTitle||'';cap.append(t,b.dataset.capText||'');
  };
  btns.forEach(b=>b.addEventListener('click',()=>setSkin(b)));
  setSkin(btns.find(b=>b.dataset.s==='s55')||btns[0]);
}

/* Barriere-Puzzle */
const pz=$('#puzzle');
if(pz){
  const pb=[...pz.querySelectorAll('.seg button')], note=$('#puzzleNote');
  const setPz=b=>{
    const m=b.dataset.m;pz.dataset.m=m;
    pb.forEach(x=>x.setAttribute('aria-pressed',x===b));
    pz.querySelectorAll('.slot').forEach(s=>{
      const lev=s.querySelector('.lev');s.classList.remove('full','half');
      if(m==='talg'){if(s.dataset.k==='cer'){s.classList.add('half');lev.style.height='45%';}else{s.classList.add('full');lev.style.height='88%';}}
      else lev.style.height='0';
      const d=s.querySelector('.wdrop');d.style.animation='none';d.offsetWidth;d.style.animation='';
    });
    note.innerHTML=b.dataset.note||'';
  };
  pb.forEach(b=>b.addEventListener('click',()=>setPz(b)));
  setPz(pb.find(b=>b.dataset.m==='talg')||pb[0]);
}

/* Fettsäure-Donut */
const dn=$('#donut'), data=$('#wtAcids');
if(dn&&data){
  const acids=JSON.parse(data.textContent), chips=$('#acidChips');
  const pol=(a,r)=>[200+r*Math.sin(a),200-r*Math.cos(a)];
  let acc=0;const tot=acids.reduce((s,a)=>s+a.v,0)||1;
  const pick=i=>{
    const a=acids[i];
    [...dn.children].forEach((p,k)=>p.classList.toggle('on',k===i));
    [...chips.children].forEach((b,k)=>b.setAttribute('aria-pressed',k===i));
    $('#donutPct').textContent=a.v+' %';$('#donutName').textContent=a.s||a.n;
    $('#acidName').textContent=a.n;$('#acidRole').textContent=a.r;$('#acidText').textContent=a.t;
  };
  acids.forEach((a,i)=>{
    const a0=acc/tot*2*Math.PI,a1=(acc+a.v)/tot*2*Math.PI;acc+=a.v;
    const R=180,r=112,big=(a1-a0)>Math.PI?1:0;
    const [x0,y0]=pol(a0,R),[x1,y1]=pol(a1,R),[x2,y2]=pol(a1,r),[x3,y3]=pol(a0,r);
    const p=document.createElementNS(NS,'path');
    p.setAttribute('d',`M${x0} ${y0}A${R} ${R} 0 ${big} 1 ${x1} ${y1}L${x2} ${y2}A${r} ${r} 0 ${big} 0 ${x3} ${y3}Z`);
    p.setAttribute('fill',a.c);p.setAttribute('tabindex','0');p.setAttribute('role','button');p.setAttribute('aria-label',a.n+', etwa '+a.v+' Prozent');
    p.addEventListener('click',()=>pick(i));p.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();pick(i);}});
    dn.appendChild(p);
    const b=document.createElement('button');b.type='button';b.style.setProperty('--c',a.c);
    b.append(document.createElement('i'),a.s||a.n);b.addEventListener('click',()=>pick(i));chips.appendChild(b);
  });
  if(acids.length)pick(0);
}

/* Vitamin-Glas */
const gW=$('#gWater'), gF=$('#gFat');
if(gW&&gF){
  const glass=(svg,liquid)=>{svg.innerHTML=`<path d="M40 30 L52 210 Q53 220 63 220 L137 220 Q147 220 148 210 L160 30" fill="none" stroke="#2B2620" stroke-width="2"/>
  <path d="M47 80 L56 208 Q57 214 64 214 L136 214 Q143 214 144 208 L153 80 Z" fill="${liquid}" opacity=".9"/>
  <path d="M47 80 Q100 88 153 80" fill="none" stroke="#2B2620" stroke-width="1" opacity=".35"/><g class="vg"></g>`;};
  glass(gW,'#D8E5EA');glass(gF,'#F0DDA9');
  const letters=['A','D','E','K'],cols=['#9A7B56','#C9A46A','#7A5F3F','#3D5A4C'],els=new Map();
  [gW,gF].forEach(svg=>{
    const g=svg.querySelector('.vg'),arr=[];
    letters.forEach((L,i)=>{
      const x=68+i*21,el=document.createElementNS(NS,'g');
      el.innerHTML=`<circle cx="${x}" cy="18" r="12" fill="${cols[i]}"/><text class="vit" x="${x}" y="18" fill="#FFFDF8">${L}</text>`;
      el.style.transition='transform 1.1s cubic-bezier(.3,.7,.2,1)';
      el.querySelector('circle').style.transition='opacity 1s .7s';el.querySelector('text').style.transition='opacity .6s .7s';
      g.appendChild(el);arr.push(el);
    });
    els.set(svg,arr);
  });
  const setVit=(end,instant)=>els.forEach((arr,svg)=>arr.forEach((el,i)=>{
    if(instant)el.style.transitionDuration='0s';
    const fat=svg===gF,dy=end?(fat?92+i*24:56+(i%2)*7):0;
    el.style.transform=`translateY(${dy}px)`;
    el.querySelector('circle').style.opacity=end&&fat?.22:1;el.querySelector('text').style.opacity=end&&fat?0:1;
    if(instant){el.offsetWidth;el.style.transitionDuration='';}
  }));
  const note=$('#glassNote');
  setVit(true,true);note.innerHTML=note.dataset.end||'';
  $('#glassBtn').addEventListener('click',()=>{
    setVit(false,true);note.innerHTML=note.dataset.start||'';
    setTimeout(()=>{setVit(true,false);setTimeout(()=>{note.innerHTML=note.dataset.end||'';},1100);},RM?50:500);
  });
}

/* Rückseiten-Vergleich */
$$('.wt .inci').forEach(list=>{
  const note=list.parentElement.querySelector('.inci-note'),chips=[...list.querySelectorAll('.chip')];
  chips.forEach(c=>c.addEventListener('click',()=>{
    chips.forEach(x=>x.setAttribute('aria-pressed',x===c));
    note.innerHTML='';const b=document.createElement('b');b.textContent=c.textContent+':';note.append(b,' '+c.dataset.note);
  }));
  (chips.find(c=>c.dataset.start)||chips[0])?.click();
});

/* Fragen-Karten */
$$('.wt .qcard').forEach(c=>c.addEventListener('click',()=>c.setAttribute('aria-pressed',c.getAttribute('aria-pressed')!=='true')));

/* Zeitstrahl */
const tl=$('#tl');
if(tl){
  const prev=$('#tlPrev'),next=$('#tlNext'),tb=$('#tlBar');
  const upd=()=>{const m=tl.scrollWidth-tl.clientWidth,p=m>0?tl.scrollLeft/m:1;
    tb.style.width=Math.max(12,p*100)+'%';prev.disabled=tl.scrollLeft<4;next.disabled=tl.scrollLeft>m-4;};
  const step=()=>(tl.querySelector('.era')?.offsetWidth||300)+18;
  prev.addEventListener('click',()=>tl.scrollBy({left:-step(),behavior:'smooth'}));
  next.addEventListener('click',()=>tl.scrollBy({left:step(),behavior:'smooth'}));
  tl.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
}

/* Kapitel-Leiste: klebt unter dem Shop-Kopf, sobald der Einstieg vorbei ist */
const nav=$('.wt .chapnav');
if(nav){
  const spacer=nav.previousElementSibling, links=[...nav.querySelectorAll('a')];
  const secs=links.map(a=>document.getElementById(a.dataset.k)), cb=nav.querySelector('.chapbar');
  const header=document.querySelector('sticky-header, .section-header .header-wrapper, .shopify-section-header-sticky');
  const navUpd=()=>{
    const hb=header?Math.max(0,header.getBoundingClientRect().bottom):0;
    const anchor=top_(nav.parentElement);
    const fix=window.scrollY+hb>=anchor;
    nav.classList.toggle('is-fixed',fix);spacer.classList.toggle('on',fix);
    spacer.style.height=fix?nav.offsetHeight+'px':'0px';
    nav.style.top=fix?hb+'px':'';
    const y=window.scrollY+hb+nav.offsetHeight+40;let on=-1;
    secs.forEach((s,i)=>{if(s&&top_(s)<=y)on=i;});
    links.forEach((a,i)=>a.classList.toggle('on',i===on));
    const real=secs.filter(Boolean);
    if(real.length&&cb){const a=top_(real[0]),last=real[real.length-1],z=top_(last)+last.offsetHeight-window.innerHeight;
      cb.style.transform='scaleX('+Math.min(1,Math.max(0,(window.scrollY-a+window.innerHeight*.3)/Math.max(1,z-a)))+')';}
  };
  window.addEventListener('scroll',navUpd,{passive:true});window.addEventListener('resize',navUpd);navUpd();
  links.forEach(a=>a.addEventListener('click',e=>{
    const s=document.getElementById(a.dataset.k);if(!s)return;e.preventDefault();
    const hb=header?Math.max(0,header.getBoundingClientRect().bottom):0;
    window.scrollTo({top:top_(s)-hb-nav.offsetHeight+2,behavior:RM?'auto':'smooth'});
  }));
}
})();
